import urls from '../api_urls/promotionActivity'
import { _post } from '@/axios/request'
export function save (params) {
  return _post(urls.SAVE, params)
}
export function findList (params) {
  return _post(urls.FIND_LIST, params)
}
export function getDetail (params) {
  return _post(urls.FIND_DETAIL, params)
}
export function del (params) {
  return _post(urls.DEL, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/promotionActivity.js